import { render, staticRenderFns } from "./box.vue?vue&type=template&id=4c005e9a&functional=true"
import script from "./box.vue?vue&type=script&lang=ts"
export * from "./box.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports